import { render } from "./matching-confirm-modal.vue?vue&type=template&id=0cbd9b82&ts=true"
import script from "./matching-confirm-modal.vue?vue&type=script&lang=ts"
export * from "./matching-confirm-modal.vue?vue&type=script&lang=ts"

import "./matching-confirm-modal.vue?vue&type=style&index=0&id=0cbd9b82&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__